<div>
  <div class="layout">
    @for (classification of classifications; track classification) {
      <div>
        <div
          [ngClass]="{
            'ghs-option': true,
            'highlight-options': isSelected(classification),
          }"
        >
          <img
            ngSrc="assets/ghs/{{ classification.code.toLowerCase() }}.svg"
            height="120"
            width="120"
            [alt]="classification.name"
          />
          <div>
            <mat-checkbox
              [checked]="!!isSelected(classification)"
              (change)="handleSelect(classification)"
            />
            <p>{{ classification.name }}</p>
          </div>
        </div>
      </div>
    }
  </div>
</div>
